import axios from 'axios'
import {Message} from 'element-ui'
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/utils/loading'
import store from '@/store'
import router from '@/router'
import {baseUrl} from '@/config'
import {removeToken} from '@/utils/auth'

// 创建一个 axios 实例
// console.log(base, 'base-------')
const service = axios.create({
    baseURL: baseUrl, // url = 基础 url + 请求 url
    // withCredentials: true, // 当跨域请求时发送 cookies
    timeout: 100000 // 请求超时
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = store.getters.token
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        // 在请求发送之前做一些处理
        if (config.headers.isLoading !== false) {
            // 如果配置了 isLoading: false，则不显示 loading
            showFullScreenLoading()
        }
        return config
    },
    error => {
        // 处理请求错误
        tryHideFullScreenLoading()
        // console.log(error) // 用于调试
        return Promise.reject(error)
    }
)

// 未登录或登录过期：清除本地登录态并跳转登录页
function handleUnauthorized() {
    removeToken() // 清除存储中的 token
    store.dispatch('user/resetToken') // 清除 Vuex 中的 token
    if (router.currentRoute.path !== '/login') {
        Message({
            message: '登录已过期，请重新登录',
            type: 'error',
            duration: 3 * 1000
        })
        router.push('/login')
    }
}

// 响应拦截器
service.interceptors.response.use(
    response => {
        tryHideFullScreenLoading()
        const res = response.data
        if (res.code !== 0) { // 修改为后端返回的成功状态码
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            // 携带响应体信息抛出，便于调用方区分业务 code（如登录失败的 401/429）
            const error = new Error(res.message || 'Error')
            error.code = res.code
            error.response = res
            return Promise.reject(error)
        } else {
            return res
        }
    },
    error => {
        tryHideFullScreenLoading()
        const status = error.response && error.response.status
        if (status === 401) {
            // 未携带 token / token 错误 / token 过期 / 已登出
            handleUnauthorized()
        } else if (status === 403) {
            // 已登录但角色权限不足
            Message({
                message: '无权限访问',
                type: 'error',
                duration: 5 * 1000
            })
        } else if (error.message && error.message.includes('Network Error')) {
            Message({
                message: '网络异常，请检查网络连接',
                type: 'error',
                duration: 5 * 1000
            })
        } else {
            Message({
                message: '内部错误，请联系管理员',
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
